import { Divider, Heading } from '@chakra-ui/react'
import { Body, Button } from '@missionlabs/react'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ESimActivationFlowProps } from '../ESimActivationFlow'

export const AddESimStep: FC<ESimActivationFlowProps> = ({ onSubmit }) => {
    const { t } = useTranslation()
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSubmit = async () => {
        if (isSubmitting) return

        setIsSubmitting(true)
        try {
            await onSubmit()
        } catch (error) {
            console.error('Error creating eSIM:', error)
            setIsSubmitting(false)
        }
    }

    return (
        <>
            <Body>{t('devices.add.eSim.announce_text')}</Body>
            <Button
                type="submit"
                size="md"
                variant="creationary"
                onClick={handleSubmit}
                isDisabled={isSubmitting}
                isLoading={isSubmitting}
                loadingText={t('devices.add.eSim.activating')}
            >
                {t('devices.add.eSim.submit')}
            </Button>
        </>
    )
}

export const SetupPendingESimStep = () => {
    const { t } = useTranslation()

    return (
        <Body>
            <Heading size="h2">{t('devices.add.eSim.pending.title')}</Heading>
            <Body>{t('devices.add.eSim.pending.subtitle')}</Body>
            <Body>{t('devices.add.eSim.pending.help')}</Body>
            <Divider my="24px" />
        </Body>
    )
}
